import React, { useState, useEffect } from 'react';
import axios from 'axios';

// const BASE_URL = "https://staging.pteshstudios.com";
const BASE_URL = "https://api.jeyshawnng.com";

const resolveSrc = (value) => {
  if (!value) return null;
  if (typeof value === "string") return value.startsWith("http") ? value : `${BASE_URL}/${value}`;
  return null;
};

const STATUS_OPTIONS = ["pending", "reviewed", "shortlisted", "rejected"];

const getBadgeClass = (type) => {
  switch (type) {
    case "Full time":         return "app-badge app-badge--permanent";
    case "Contract":          return "app-badge app-badge--contract";
    case "Internship / NYSC": return "app-badge app-badge--internship";
    case "Ad-hoc":            return "app-badge app-badge--temporary";
    default:                  return "app-badge app-badge--default";
  }
};

const getStatusClass = (status) => {
  switch (status) {
    case "pending":     return "app-badge app-badge--contract";
    case "reviewed":    return "app-badge app-badge--default";
    case "shortlisted": return "app-badge app-badge--permanent";
    case "rejected":    return "app-badge app-badge--temporary";
    default:            return "app-badge app-badge--default";
  }
};

/* ── Detail Modal ── */
const AppDetailModal = ({ app, onClose, onStatusChange }) => {
  const [status,  setStatus]  = useState(app.status || "pending");
  const [saving,  setSaving]  = useState(false);

  if (!app) return null;
  const p  = app.personalDetails        || {};
  const pi = app.positionInformation    || {};
  const ed = app.education              || {};
  const ce = app.certifications         || {};
  const we = app.workExperience         || {};
  const sk = app.skills                 || {};
  const ny = app.nysc                   || {};
  const do_ = app.documents             || {};
  const ad = app.additional             || {};

  const handleStatusSave = async () => {
    setSaving(true);
    try {
      await axios.patch(`${BASE_URL}/api/applications/${app._id}/status`, { status });
      onStatusChange(app._id, status);
      onClose();
    } catch (err) {
      console.error("Status update failed:", err);
    } finally {
      setSaving(false);
    }
  };

  const DocLink = ({ label, url }) => {
    const src = resolveSrc(url);
    return src
      ? <a href={src} target="_blank" rel="noreferrer" className="app-cv-link">{label}</a>
      : <span className="app-cv-none">—</span>;
  };

  const Row = ({ label, value }) => value
    ? <div className="app-detail-row"><span className="app-detail-label">{label}</span><span className="app-detail-value">{value}</span></div>
    : null;

  return (
    <div className="em-overlay" onClick={onClose}>
      <div className="em-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 760 }}>
        <div className="em-header">
          <h2 className="em-title">{p.fullName || "Application"}</h2>
          <button className="em-close" onClick={onClose}>&times;</button>
        </div>
        <div className="em-body">

          <p className="editor-section__title">Personal Details</p>
          <div className="em-expertise-card">
            <Row label="Full Name"           value={p.fullName} />
            <Row label="Date of Birth"       value={p.dateOfBirth} />
            <Row label="Age"                 value={p.age} />
            <Row label="Gender"              value={p.gender} />
            <Row label="Marital Status"      value={p.maritalStatus} />
            <Row label="Nationality"         value={p.nationality} />
            <Row label="State of Origin"     value={p.stateOfOrigin} />
            <Row label="LGA"                 value={p.lga} />
            <Row label="Email"               value={p.email} />
            <Row label="Phone"               value={p.phoneNumber} />
            <Row label="Residential Address" value={p.residentialAddress} />
            <Row label="State of Residence"  value={p.stateOfResidence} />
            <Row label="LGA of Residence"    value={p.residentialLocalGovernment} />
          </div>

          <p className="editor-section__title">Position Information</p>
          <div className="em-expertise-card">
            <Row label="Role Applied For" value={pi.positionAppliedFor} />
            <Row label="Department"       value={pi.department} />
            <Row label="Employment Type"  value={pi.employmentType} />
          </div>

          <p className="editor-section__title">Education</p>
          <div className="em-expertise-card">
            <Row label="Highest Qualification" value={ed.highestQualification} />
            <Row label="Institution"           value={ed.institution} />
            <Row label="Course of Study"       value={ed.courseOfStudy} />
            <Row label="Class / Grade"         value={ed.classGrade} />
            <Row label="Year of Graduation"    value={ed.yearOfGraduation} />
            <Row label="Other Qualifications"  value={ed.otherQualifications} />
          </div>

          <p className="editor-section__title">Certifications</p>
          <div className="em-expertise-card">
            <Row label="Certification Name" value={ce.certificationName} />
            <Row label="Issuing Body"       value={ce.issuingBody} />
            <Row label="Year Obtained"      value={ce.yearObtained} />
          </div>

          <p className="editor-section__title">Work Experience</p>
          <div className="em-expertise-card">
            <Row label="Current Employer"      value={we.currentEmployer} />
            <Row label="Job Title"             value={we.jobTitle} />
            <Row label="Key Responsibilities"  value={we.keyResponsibilities} />
          </div>

          <p className="editor-section__title">Skills</p>
          <div className="em-expertise-card">
            <Row label="Technical Skills" value={sk.technicalSkills} />
            <Row label="Soft Skills"      value={sk.softSkills} />
            <Row label="IT Proficiency"   value={sk.itProficiency} />
          </div>

          <p className="editor-section__title">NYSC</p>
          <div className="em-expertise-card">
            <Row label="NYSC Status"            value={ny.status} />
            <Row label="Certificate Number"     value={ny.certificateNumber} />
          </div>

          <p className="editor-section__title">Additional Information</p>
          <div className="em-expertise-card">
            <Row label="Why Suitable" value={ad.whySuitable} />
            <Row label="Availability" value={ad.availability} />
          </div>

          <p className="editor-section__title">Documents</p>
          <div className="em-expertise-card" style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
            <DocLink label="CV"              url={do_.cv} />
            <DocLink label="Cover Letter"    url={do_.coverLetter} />
            <DocLink label="Certificate 1"   url={do_.certificates1} />
            <DocLink label="Certificate 2"   url={do_.certificates2} />
            <DocLink label="Certificate 3"   url={do_.certificates3} />
            <DocLink label="Certificate 4"   url={do_.certificates4} />
            <DocLink label="Certificate 5"   url={do_.certificates5} />
          </div>

          <p className="editor-section__title">Update Status</p>
          <div className="em-expertise-card" style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <select className="em-input" value={status} onChange={e => setStatus(e.target.value)}
              style={{ maxWidth: 200 }}>
              {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
            <button className="em-btn-save" onClick={handleStatusSave} disabled={saving}>
              {saving ? "Saving..." : "Save Status"}
            </button>
          </div>

        </div>
        <div className="em-footer">
          <button className="em-btn-cancel" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

/* ── Main Component ── */
const AdminApplications = () => {
  const [applications, setApplications] = useState([]);
  const [loading,      setLoading]      = useState(false);
  const [fetchError,   setFetchError]   = useState(null);
  const [showToast,    setShowToast]    = useState(false);
  const [search,       setSearch]       = useState("");
  const [filterType,   setFilterType]   = useState("All");
  const [filterStatus, setFilterStatus] = useState("All");
  const [selectedApp,  setSelectedApp]  = useState(null);

  const fetchApplications = async () => {
    setLoading(true);
    setFetchError(null);
    try {
      const { data } = await axios.get(`${BASE_URL}/api/applications`);
      const payload = data?.data ?? data;
      const list = Array.isArray(payload) ? payload : payload?.applications ?? [];
      setApplications(list);
    } catch (err) {
      console.error("Failed to fetch applications:", err);
      setFetchError(err.message);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 5000);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchApplications(); }, []);

  const handleStatusChange = (id, newStatus) => {
    setApplications(prev => prev.map(a => a._id === id ? { ...a, status: newStatus } : a));
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this application?")) return;
    try {
      await axios.delete(`${BASE_URL}/api/applications/${id}`);
      setApplications(prev => prev.filter(a => a._id !== id));
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  const employmentTypes = ["All", "Full time", "Contract", "Internship / NYSC", "Ad-hoc"];
  const statusTypes     = ["All", ...STATUS_OPTIONS];

  const filtered = applications.filter(app => {
    const matchesType   = filterType   === "All" || app.positionInformation?.employmentType === filterType;
    const matchesStatus = filterStatus === "All" || app.status === filterStatus;
    const q = search.toLowerCase();
    const matchesSearch = !q
      || app.personalDetails?.fullName?.toLowerCase().includes(q)
      || app.positionInformation?.department?.toLowerCase().includes(q)
      || app.personalDetails?.email?.toLowerCase().includes(q);
    return matchesType && matchesStatus && matchesSearch;
  });

  return (
    <div>
      {/* PAGE HEADER */}
      <div className="content-wrapper">
        <div className="top-bar">
          <button className="app-refresh-btn" onClick={fetchApplications} disabled={loading} title="Refresh">
            {loading ? "..." : "↻"}
          </button>
        </div>
        <div className="text-section_app ">
          <p className="aboutusId wow animate__animated animate__fadeInUp">
            <span className="aboutusId-link">Admin</span>
            <span className="separator">{">"}</span>
            <span className="aboutusId-link active">Applications</span>
          </p>
          <h1 className="main-headings wow animate__animated animate__fadeInUp">Job Applications</h1>
        </div>
      </div>

      {/* TOOLBAR */}
      <div className="app-toolbar">
        <input type="text" className="app-search"
          placeholder="Search by name, department, email..."
          value={search} onChange={e => setSearch(e.target.value)} />
        <div className="app-filter-tabs">
          {employmentTypes.map(type => (
            <button key={type}
              className={`app-filter-tab ${filterType === type ? "active" : ""}`}
              onClick={() => setFilterType(type)}>
              {type}
            </button>
          ))}
        </div>
        <div className="app-filter-tabs">
          {statusTypes.map(s => (
            <button key={s}
              className={`app-filter-tab ${filterStatus === s ? "active" : ""}`}
              onClick={() => setFilterStatus(s)}>
              {s}
            </button>
          ))}
        </div>
        <span className="app-count">
          {filtered.length} application{filtered.length !== 1 ? "s" : ""}
        </span>
      </div>

      {/* TABLE */}
      <div className="app-table-wrapper">
        {loading ? (
          <p className="app-empty">Loading applications...</p>
        ) : filtered.length === 0 ? (
          <p className="app-empty">
            {applications.length === 0 ? "No applications received yet." : "No results match your search."}
          </p>
        ) : (
          <table className="app-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Full Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Role</th>
                <th>Department</th>
                <th>Type</th>
                <th>Availability</th>
                <th>CV</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((app, index) => (
                <tr key={app._id || index} style={{ cursor: "pointer" }}>
                  <td>{index + 1}</td>
                  <td className="app-td--name" onClick={() => setSelectedApp(app)}>
                    {app.personalDetails?.fullName || "—"}
                  </td>
                  <td>{app.personalDetails?.email || "—"}</td>
                  <td>{app.personalDetails?.phoneNumber || "—"}</td>
                  <td>{app.positionInformation?.positionAppliedFor || "—"}</td>
                  <td>{app.positionInformation?.department || "—"}</td>
                  <td>
                    <span className={getBadgeClass(app.positionInformation?.employmentType)}>
                      {app.positionInformation?.employmentType || "—"}
                    </span>
                  </td>
                  <td>{app.additional?.availability || "—"}</td>
                  <td>
                    {resolveSrc(app.documents?.cv)
                      ? <a href={resolveSrc(app.documents?.cv)} target="_blank" rel="noreferrer" className="app-cv-link">View</a>
                      : <span className="app-cv-none">—</span>}
                  </td>
                  <td>
                    <span className={getStatusClass(app.status)}>{app.status || "pending"}</span>
                  </td>
                  <td style={{ display: "flex", gap: 6 }}>
                    <button className="em-btn-save" style={{ padding: "4px 10px", fontSize: 12 }}
                      onClick={() => setSelectedApp(app)}>View</button>
                    <button className="em-remove-btn" style={{ padding: "4px 10px", fontSize: 12 }}
                      onClick={() => handleDelete(app._id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* DETAIL MODAL */}
      {selectedApp && (
        <AppDetailModal
          app={selectedApp}
          onClose={() => setSelectedApp(null)}
          onStatusChange={handleStatusChange}
        />
      )}

      {/* TOAST */}
      {showToast && (
        <div className="em-toast em-toast--error">
          <div className="em-toast-body">
            <p className="em-toast-title">Failed to load applications</p>
            <p className="em-toast-message">{fetchError}</p>
          </div>
          <button className="em-toast-close" onClick={() => setShowToast(false)}>✕</button>
        </div>
      )}
    </div>
  );
};

export default AdminApplications;